import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { sendNotification } from 'src/redux/actions/notifications';
import { findAllStock } from 'src/redux/actions/stock';
import { addRequest, findJobNumbers } from 'src/redux/actions/request';
import { withRouter, Link } from 'react-router-dom';

class Stock extends Component {
  render = () => {
    const {
      Layout,
      stock,
      user,
      findAllStock,
      addRequest,
      sendNotification,
      push,
      findJobNumbers,
      history
    } = this.props;
    return (
      <Layout
        stock={stock}
        user={user}
        findAllStock={findAllStock}
        addRequest={addRequest}
        sendNotification={sendNotification}
        push={push}
        findJobNumbers={findJobNumbers}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  stock: state.stock.allStock || [],
  user: state.user.user || {}
});

const mapDispatchToProps = {
  findAllStock,
  addRequest,
  sendNotification,
  push,
  findJobNumbers
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Stock)
);
